import React from 'react';
import styles from './ManagerCard.module.css';

interface Manager {
  id: number;
  name: string;
  phone: string;
  projects: string[];
  dispatcher_phone: string;
  email: string;
  working_hours: string;
}

export default function ManagerCard({ manager }: { manager: Manager }) {
  const cleanPhoneNumber = (phone: string) => {
    return phone.replace(/[^\d+]/g, '');
  };

  const renderPhoneLink = (phone: string) => {
    const cleanedPhone = cleanPhoneNumber(phone);
    return (
      <a href={`tel:${cleanedPhone}`} className='text_body_b2'>
        <span dangerouslySetInnerHTML={{ __html: phone }} />
      </a>
    );
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.left_content}>
        <div className={styles.label_text}>
          <div className={styles.label}>
            <span className='text_captions_c2'>ООО УО</span>
          </div>
          <h4>«{manager.name}»</h4>
        </div>
        <div className={styles.label_text}>
          <div className={styles.label}>
            <span className='text_captions_c2'>ПРОЕКТЫ</span>
          </div>
          <div className={styles.projects}>
            {manager.projects.map((project, index) => (
              <React.Fragment key={index}>
                <span className='text_body_b2'>{project}</span>
                {index < manager.projects.length - 1 && <span className={styles.divider}></span>}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
      <div className={styles.right_content}>
        <div className={styles.phones_wrapper}>
          <div className={styles.label_text}>
            <div className={styles.label}>
              <span className='text_captions_c2'>ТЕЛЕФОН УПРАВЛЯЮЩЕЙ КОМПАНИИ</span>
            </div>
            <div className={styles.text}>
              <p>{renderPhoneLink(manager.phone)}</p>
            </div>
          </div>
          <div className={styles.label_text}>
            <div className={styles.label}>
              <span className='text_captions_c2'>ТЕЛЕФОН ДИСПЕТЧЕРСКОЙ СЛУЖБЫ</span>
            </div>
            <div className={styles.text}>
              <p>{renderPhoneLink(manager.dispatcher_phone)}</p>
            </div>
          </div>
        </div>
        <div className={styles.label_text}>
          <div className={styles.label}>
            <span className='text_captions_c2'>ПОЧТА</span>
          </div>
          <div className={styles.text}>
            <p className='text_body_b2'>{manager.email}</p>
          </div>
        </div>
        <div className={styles.label_text}>
          <div className={styles.label}>
            <span className='text_captions_c2'>РЕЖИМ РАБОТЫ</span>
          </div>
          <div className={styles.text}>
            <p className='text_body_b2' dangerouslySetInnerHTML={{ __html: manager.working_hours }} />
          </div>
        </div>
      </div>
    </div>
  );
}